import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { formatPrice, isNil } from "@grandvisionhq/utils";
import { Regular } from "../../../../layout/modules/Totals/layout/Regular.js";
/* empty css                                                            */
import { useCartSettings } from "../../../../../../context/CartSettings/context/CartSettings/context.js";
import { useCart } from "../../../../../../context/Cart/context/Cart/context.js";
const TotalsContainer = ({
  className,
  isMiniCart,
  selectedPaymentMethodPrice,
  shouldShowSubTotal,
  shouldShowTotalDiscount
}) => {
  const settings = useCartSettings();
  const { cart } = useCart();
  const { locale, currency, getLabel, getFormattedLabel } = useIntl();
  const discountedPrice = cart?.prices.discountPrice ? cart.prices.subTotalPrice - cart.prices.discountPrice : cart?.prices.subTotalPrice || 0;
  const freeShippingRemainder = cart?.shippingMethod.freeAbove ? cart.shippingMethod.freeAbove - discountedPrice : void 0;
  const formattedPrice = formatPrice({
    locale,
    value: freeShippingRemainder,
    currency,
    isCentAmount: true
  });
  const labels = React.useMemo(
    () => ({
      delivery: getLabel("cart.delivery"),
      freeDelivery: getLabel("cart.delivery.forFree"),
      subTotal: getLabel("cart.value.subTotal"),
      total: getLabel("cart.value.total"),
      todaysTotal: getLabel("cart.value.todaysTotal"),
      totalDiscount: getLabel("cart.value.totalDiscount"),
      paymentMethodPrice: getLabel("cart.value.paymentMethod"),
      freeShippingRemainder: getFormattedLabel("cart.delivery.freeShippingRemainder", {
        parseHTML: true,
        labelData: { price: `<span className="price">${formattedPrice}</span>` }
      }),
      freeShippingReached: getLabel("cart.delivery.freeShippingReached"),
      totalItems: getLabel("cart.value.totalItems"),
      productDiscounts: getLabel("cart.value.productDiscounts")
    }),
    [getLabel, getFormattedLabel, formattedPrice]
  );
  if (!cart) {
    return null;
  }
  const emulatedTotalCartPrice = selectedPaymentMethodPrice?.emulatedTotalCartPrice;
  const additionalCosts = selectedPaymentMethodPrice?.additionalCosts;
  const prices = emulatedTotalCartPrice && additionalCosts ? { ...cart.prices, totalPrice: emulatedTotalCartPrice, paymentMethodPrice: additionalCosts } : cart.prices;
  const cartSettings = {
    ...settings,
    shouldShowSubTotal: !isNil(shouldShowSubTotal) ? shouldShowSubTotal : settings.shouldShowSubTotal,
    shouldShowTotalDiscount: !isNil(shouldShowTotalDiscount) ? shouldShowTotalDiscount : settings.shouldShowTotalDiscount
  };
  return /* @__PURE__ */ React.createElement(
    Regular,
    {
      className,
      currency,
      labels,
      prices,
      settings: cartSettings,
      voucherCodes: cart.voucherCodes,
      freeShippingThreshold: cart.shippingMethod.freeAbove,
      discountedPrice,
      isMiniCart,
      numberOfItems: cart.numberOfItems
    }
  );
};
export {
  TotalsContainer
};
//# sourceMappingURL=TotalsContainer.js.map
